import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DisabledTransaction } from '../types/disabledTransaction';

type TransactionsState = DisabledTransaction[];

const disabledTransactionsSlice = createSlice({
  name: 'disabledTransactions',
  initialState: [] as TransactionsState,
  reducers: {
    updateDisabledTransaction: (
      state,
      action: PayloadAction<DisabledTransaction>
    ) => {
      const existingIndex = state.findIndex(
        (transaction) => transaction.id === action.payload.id
      );

      if (existingIndex >= 0) {
        // Update existing transaction
        state[existingIndex] = action.payload;
      } else {
        // Add new transaction
        state.push(action.payload);
      }
    },
    createDisabledTransaction: (
      state,
      action: PayloadAction<DisabledTransaction>
    ) => {
      state.push(action.payload);
    },
    clearDisabledTransaction: (state, action: PayloadAction<string>) => {
      return state.filter((transaction) => transaction.id !== action.payload);
    },
  },
});

export const {
  updateDisabledTransaction,
  createDisabledTransaction,
  clearDisabledTransaction,
} = disabledTransactionsSlice.actions;

export default disabledTransactionsSlice.reducer;
